import React, { useState } from 'react';
import { endpoints } from '../api';
import { useNavigate } from 'react-router-dom';

const Schedule = () => {
    const [type, setType] = useState("now");
    const navigate = useNavigate();
    const save = async () => {
        await endpoints.saveSchedule({
            user_email: localStorage.getItem('user_email'),
            campaign_name: localStorage.getItem('active_campaign'),
            schedule_type: type
        });
        navigate('/tracker');
    };
    return (
        <div className="card">
            <select onChange={e => setType(e.target.value)}><option value="now">Now</option><option value="scheduled">Scheduled</option></select>
            <button className="btn" onClick={save}>Save Schedule</button>
        </div>
    );
};
export default Schedule;